module.exports = "/_next/static/images/icon-favorite-star-hover-4f3855e9af9ac8001b25526beff0fffb.svg";